/* eslint-disable */
/* eslint-disable react/no-unused-prop-types */
import { memo, useEffect, useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import CustomErrorText from "../CustomErrorText";

interface Props {
  className?: string;
  optionsClassName?: string;
  label?: string;
  options: string[];
  name: string;
  touched?: boolean;
  error?: string;
  setFieldValue: (field: string, value: string) => void;
  setFieldTouched: (field: any, touched: boolean) => void;
  requiredStar?: boolean;
  defaultValue?: string;
  defaultValueIndex?: number;
  disabled?: boolean;
  optionContainerClasses?: string;
}
function CustomRadioButton({
  className,
  optionsClassName,
  label,
  options,
  name,
  touched,
  error,
  setFieldValue,
  setFieldTouched,
  requiredStar,
  defaultValue,
  disabled,
  optionContainerClasses
}: Props) {
  const [selectedIndex, setSelectedIndex] = useState(options.indexOf(defaultValue!));
  useEffect(() => {
    // eslint-disable-next-line security/detect-object-injection
    console.log(
      "CustomRadioButton Rendered",
      name,
      defaultValue,
      selectedIndex,
      options[selectedIndex!]
    );
    setFieldValue(name, options[selectedIndex!] || "");
  }, [selectedIndex]);
  // console.log("radio button values", defaultValue, options);
  return (
    <div className={className}>
      <div>
        <RadioGroup classes={{ root: "!text-left" }}>
          <span className="text-left text-xs font-medium !font-montserrat">{`${label} ${
            requiredStar ? "*" : ""
          }`}</span>
          <div className={optionContainerClasses}>
            {options?.map((option, index) => (
              <FormControlLabel
                key={option}
                classes={{
                  label: `!text-sm !font-normal !font-montserrat !mt-1.5 !-ml-1 ${
                    index === options.length - 1 && "!-mr-4"
                  }`
                }}
                value={option}
                // eslint-disable-next-line security/detect-object-injection
                onClick={() => !disabled && setSelectedIndex(index)}
                onBlur={() => setFieldTouched(name, true)}
                control={
                  <Radio
                    disableRipple
                    checked
                    classes={{
                      root: `!mt-1 ${optionsClassName}`,
                      checked: `${
                        index === selectedIndex ? "!text-durotarFire" : "!text-discoBall"
                      }`
                    }}
                  />
                }
                label={option}
              />
            ))}
          </div>
        </RadioGroup>
      </div>
      {touched && error && <CustomErrorText className="!-mt-1.25" text={error} type="error" />}
    </div>
  );
}

CustomRadioButton.defaultProps = {
  className: "",
  optionsClassName: "",
  requiredStar: false,
  touched: "",
  error: "",
  defaultValue: "",
  label: "",
  defaultValueIndex: -1,
  disabled: false
};

export default memo(CustomRadioButton);
